import { useMgoClient } from '@mgonetwork/dapp-kit';
import { useQuery } from '@tanstack/react-query';

export function useGetAddressMetrics() {
	const client = useMgoClient();
	return useQuery({
		queryKey: ['home', 'addresses'],
		queryFn: () => client.getAddressMetrics(),
		cacheTime: 24 * 60 * 60 * 1000,
		staleTime: Infinity,
		retry: 5,
	});
}
